(function (module) {
    'use strict';

    function ChangePasswordCtrl(User, LoopBackAuth, $state) {
        this.$onInit = () => {
            User
                .getCurrent()
                .$promise
                .then((response) => {
                    this.current = response;
                });

        };

        this.savePass = () => {
            this.api = {};

            User
                .changePassword({
                    oldPassword: this.current.oldPassword,
                    newPassword: this.current.password,
                })
                .$promise
                .then((response) => {
                    LoopBackAuth.setUser(response.id, response.userId, response.user);
                    LoopBackAuth.rememberMe = true;
                    LoopBackAuth.save();

                    $state.go('logout');

                })
                .catch((error) => {
                    this.api.message = error.data.error.message;
                });
        };
    }

    module
        .config(function ($stateProvider) {
            $stateProvider
                .state('root.my-profile.change-password', {
                    url: '/change-password',
                    data: {
                        pageTitle: 'MY_PROFILE_CHANGE_PASSWORD.PAGE_TITLE'
                    },
                    views: {
                        'content@root': {
                            template: '<change-password-component />'

                        }
                    }
                });
        })
        .component('changePasswordComponent', {
            templateUrl: '/js/my-profile/change-password/change-password.html',
            controller: ChangePasswordCtrl
        });

})(angular.module('rocket.components'));
